import validate from "/usr/src/app/content/n3-spas-63cf48a4-38ea-4539-93fb-4f76f78c720b/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-63cf48a4-38ea-4539-93fb-4f76f78c720b/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}